export default [{
  path: '/login',
  children: [{
    path: 'index',
    name: '登录',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/login/login.vue')
  }, {
    path: 'regist',
    name: '注册',
    meta: {
      title: '注册'
    },
    component: () => import('@/views/login/registe.vue')
  }, {
    path: 'agreement',
    name: '注册协议',
    meta: {
      title: '注册协议'
    },
    component: () => import('@/views/login/agreement.vue')
  }, {
    path: 'forgot',
    name: '忘记密码',
    meta: {
      title: '忘记密码'
    },
    component: () => import('@/views/login/forgotPwd.vue')
  },{
    path: 'changePwd',
    name: '修改密码 ',
    meta: {
      title: '修改密码'
    },
    component: () => import('@/views/login/changePwd.vue')
  }]
}]